import { useState } from 'react';
import { RhythmFigureIcon } from '../../components/ecoRitmico/RhythmFigureIcon';
import { boomFigureEcoFallback, boomFigureHasEcoSprite } from '../lib/boomFigureMap';
import { VexFigureIcon } from './VexFigureIcon';
import type { NoteFigure } from '../types';

interface Props {
  figure: NoteFigure;
  className?: string;
  filled?: boolean;
  size?: number;
  color?: string;
  /** En picker se priorizan ilustraciones PNG (Eco Rítmico) dentro del círculo. */
  display?: 'default' | 'picker';
}

/** Icono de figura rítmica: VexFlow (Bravura) o PNG de Eco Rítmico como respaldo. */
export function FigureIcon({
  figure,
  className = '',
  size = 44,
  color = '#2A2540',
  display = 'default',
}: Props) {
  const ecoId = boomFigureEcoFallback(figure);
  const [useEco, setUseEco] = useState(false);

  if (display === 'picker' && ecoId && boomFigureHasEcoSprite(figure)) {
    return (
      <RhythmFigureIcon
        figureId={ecoId}
        size={size}
        className={className}
        bare
      />
    );
  }

  if (useEco && ecoId) {
    return (
      <RhythmFigureIcon
        figureId={ecoId}
        size={size}
        color={color}
        className={className}
        bare
      />
    );
  }

  const vexColor = display === 'picker' ? '#ffffff' : color;

  return (
    <VexFigureIcon
      figure={figure}
      size={size}
      color={vexColor}
      className={className}
      onFailed={() => {
        if (ecoId) setUseEco(true);
      }}
    />
  );
}
